<template>
  <div :class="`my-5 text-${position}`" id="lqlq">
    <v-btn @click="openDialog" color="primary">
      <v-icon class="mr-3">mdi-download</v-icon>
      Свали файлове
    </v-btn>
    <v-dialog
      v-model="open"
      max-width="40%"
      id="filesModal"
    >
      <base-material-card
        hover-reveal
        color="primary"
        icon="mdi-download"
        inline
        class="px-5 py-5"
      >
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">Свали файл</div>
        </template>
            
        <v-form ref="downloadMarketFilesForm" class="mt-3">
          <v-row>
            <v-col cols="4" class="mx-auto" v-if="financialSystem === 'amundi'">
              <v-autocomplete
                v-model="fileType"
                :items="amundiFileTypes"
                item-text="label"
                item-value="value"
                label="Тип файл"
                no-data-text="Няма налични файлове"
                autocomplete="off"
                clearable
                @change="loadFiles"
              />
            </v-col>
            <v-col :cols="financialSystem === 'amundi' ? 4 : 8" class="mx-auto">
              <v-autocomplete
                v-model="fileName"
                :items="fileNames"
                item-text="label"
                item-value="value"
                label="Изтегли файл"
                no-data-text="Няма налични файлове"
                autocomplete="off"
                clearable
                @change="removeMessage"
              />
            </v-col>
            <v-col cols="4" class="mx-auto">
              <v-btn color="primary" block @click="downloadMarketFileData">Изтегли</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="message">
            <v-col cols="12" class="red--text">
              *{{message}}
            </v-col>
          </v-row>
        </v-form>

        <template v-slot:actions>
          <v-btn @click="open = !open">Затвори</v-btn>
        </template>
      </base-material-card>
    </v-dialog>
  </div>
</template>

<script>

//import { downloadFileFromResponse } from '@/utils';

export default {
  name: 'marketsDownloadFiles',
  props: {
    financialSystem: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      open: false,
      expandDownloads: false,
      fileName: '',
      message: '',
      amundiFileTypes: [
        { label: 'Conversion', value: 'amundiConversion' },
        { label: 'Portfolio', value: 'amundiPortfolio' },
        { label: 'Transfers', value: 'amundiTransfers' },
        { label: 'Subscriptions', value: 'amundiSubscriptions' },
        { label: 'Redemption', value: 'amundiRedemption' },
      ],
      fileType: '',
      fileNames: []
    };
  },
  mounted() {},
  methods: {
    openDialog(){
      if(!this.fileNames.length)
        this.loadFiles();

      this.open = true;
    },
    downloadMarketFileData(){
      this.message = '';
      if(this.financialSystem && this.fileName){
        // let query = {
        //   financialSystem: this.financialSystem === 'amundi' ? this.fileType : this.financialSystem,
        //   fileName: this.fileName
        // }
        // downloadMarketFile(query).then(response => {
        //   downloadFileFromResponse(response);
        // })
      } else {
        this.message = 'Моля изберете файл.';
      }
    },
    removeMessage(){
      this.message = '';
    },
    loadFiles(){
      switch(this.financialSystem){
        case 'amundi':
          switch(this.fileType){
            case 'amundiConversion':
              // getAmundiConversionFileNames().then(data => {
              //   this.fileNames = data;
              // })
            break;
            case 'amundiPortfolio':
              // getAmundiPortfolioFileNames().then(data => {
              //   this.fileNames = data;
              // })
            break;
            case 'amundiTransfers':
              // getAmundiTransfersFileNames().then(data => {
              //   this.fileNames = data;
              // })
            break;
            case 'amundiSubscriptions':
              // getAmundiSubscriptionsFileNames().then(data => {
              //   this.fileNames = data;
              // })
            break;
            case 'amundiRedemption':
              // getAmundiRedemptionFileNames().then(data => {
              //   this.fileNames = data;
              // })
            break;
          }

          this.removeMessage();
        break;
        case 'custodyManager':
          // getCustodyManagerFileNames().then(data => {
          //   this.fileNames = data;
          // })
        break;
        case 'kondor':
          // getKondorFileNames().then(data => {
          //   this.fileNames = data;
          // })
        break;
        case 'market':
          // getMarketFileNames().then(data => {
          //   this.fileNames = data;
          // })
        break;
        case 'securitiesManager':
          // getSecuritiesManagerFileNames().then(data => {
          //   this.fileNames = data;
          // })
        break;
      }
    }
  }
};
</script>

<style lang="sass">
.v-dialog
  overflow-y: visible !important
</style>